import {
  getSectionFullCode,
  prepareSectionMetadata,
} from '../../../actions/helpers/section.helper';
import { createSectionApi, updateSectionApi } from '../../../api/sections';
import { clearSurveyCacheApi } from '../../../api/surveys';

// Saves a section's name and code: creates the metadata entry when the section
// has none yet (Id === -1), updates it otherwise, then clears the survey cache.
// A code change on an entry this survey does not own outright (a legacy entry
// keyed by the bare code or a per-survey override, which other surveys may
// still resolve through) creates a new entry instead of rewriting the shared
// one. storedCode on the selection is the entry's code as stored.
// Returns the updated selected-section object for the caller's local state.
const saveSurveySection = async ({ sectionInfo, selectedSection, survey, jwt }) => {
  const codeWithSurveyData = getSectionFullCode(sectionInfo.code, survey);
  const normalizedCode = sectionInfo.code?.split('#')?.[0] ?? sectionInfo.code;
  const previousCode = selectedSection.Data.code;

  const codeChanged =
    !!previousCode && previousCode.toLowerCase() !== normalizedCode?.toLowerCase();
  const ownsEntry =
    !!selectedSection.storedCode &&
    selectedSection.storedCode.toLowerCase() ===
      getSectionFullCode(previousCode, survey)?.toLowerCase();
  const createEntry = selectedSection.Id === -1 || (codeChanged && !ownsEntry);

  const sectionPayload = {
    ...selectedSection.Data,
    name: sectionInfo.title,
    code: codeWithSurveyData,
  };

  if (createEntry) {
    const { overrides, ...newEntry } = sectionPayload;
    await createSectionApi(newEntry, jwt);
  } else {
    const updatePayload = prepareSectionMetadata(sectionPayload, selectedSection.Data, survey);
    await updateSectionApi(selectedSection.Id, updatePayload, jwt);
  }

  await clearSurveyCacheApi(survey.id, jwt);

  const finalMetadata = prepareSectionMetadata(
    {
      ...selectedSection.Data,
      name: sectionInfo.title,
      code: normalizedCode,
    },
    selectedSection.Data,
    survey
  );

  return {
    ...selectedSection,
    // A freshly created entry only gets its Id once the list is refetched.
    Id: createEntry ? -1 : selectedSection.Id,
    storedCode: codeWithSurveyData,
    Data: {
      ...finalMetadata,
      code: normalizedCode,
    },
  };
};

export default saveSurveySection;
